module.exports = __webpack_public_path__ + "static/img/10016.64469e9d.png";